export default __webpack_public_path__ + "static/media/hide.599d013b.svg";